module.exports = __webpack_public_path__ + "static/img/noorder_pic.d667cbe.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/common/noorder_pic.png
// module id = NYHY
// module chunks = 96